import { createSlice } from "@reduxjs/toolkit";
import { getCandidatesByUserId } from "./Thunk";

export const userProfile = createSlice({
  name: "UserProfile",
  initialState: {
    isLoading: false,
    candidateInfo: [],
    startInfoModalIsShown: false,
  },
  reducers: {
    SetStartInfoModalIsShown(state, action) {
      state.startInfoModalIsShown = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCandidatesByUserId.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getCandidatesByUserId.fulfilled, (state, action) => {
      state.isLoading = false;
      state.candidateInfo = action.payload;
    });
  },
});

export const { SetStartInfoModalIsShown } = userProfile.actions;

export default userProfile.reducer;
